import React from "react";
import { Card, CardContent } from "../ui/card";
import { Users, Shield, Crown, User } from "lucide-react";

const UserStats = ({ users, contextType }) => {
  // For organization context, we need to count different role types
  const getStats = () => {
    if (contextType === "organization") {
      return {
        total: users.length,
        orgAdmins: users.filter((user) =>
          user.roles.some((role) => role.type === "org_admin")
        ).length,
        businessUnitHeads: users.filter((user) =>
          user.roles.some((role) => role.type === "business_unit_head")
        ).length,
        businessUsers: users.filter((user) =>
          user.roles.some((role) => role.type === "business_user")
        ).length,
      };
    } else {
      // For business unit context
      return {
        total: users.length,
        businessUnitHeads: users.filter(
          (user) => user.role === "business_unit_head"
        ).length,
        businessUsers: users.filter((user) => user.role === "business_user")
          .length,
      };
    }
  };

  const stats = getStats();

  return (
    <div
      className={`grid grid-cols-1 md:grid-cols-${
        contextType === "organization" ? "4" : "3"
      } gap-4 mb-8`}
    >
      <Card>
        <CardContent className="pt-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-muted-foreground">
                Total Users
              </p>
              <p className="text-2xl font-bold">{stats.total}</p>
            </div>
            <Users className="h-8 w-8 text-muted-foreground" />
          </div>
        </CardContent>
      </Card>

      {contextType === "organization" && (
        <Card>
          <CardContent className="pt-6">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-muted-foreground">
                  Organization Admins
                </p>
                <p className="text-2xl font-bold">{stats.orgAdmins}</p>
              </div>
              <Shield className="h-8 w-8 text-muted-foreground" />
            </div>
          </CardContent>
        </Card>
      )}

      <Card>
        <CardContent className="pt-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-muted-foreground">
                Business Unit Heads
              </p>
              <p className="text-2xl font-bold">{stats.businessUnitHeads}</p>
            </div>
            <Crown className="h-8 w-8 text-muted-foreground" />
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardContent className="pt-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-muted-foreground">
                Business Users
              </p>
              <p className="text-2xl font-bold">{stats.businessUsers}</p>
            </div>
            <User className="h-8 w-8 text-muted-foreground" />
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default UserStats;
